import CSVFileUploader from './CSVFileUploader';
import OutputDataUploader from './OutputDataUploader';
import TimeInformationInput from './TimeInformationInput';
import AllgemeineDaten from './AllgemeineDaten';
import { CSVFileEntry, TimeInformationDatabaseData, ZeitschritteData } from '../../../types/common';

interface TrainingDataUploadProps {
    resetKey: number;
    zeitschritte: ZeitschritteData;
    uploadSessionId: string | null;
    onZeitschritteChange: (data: ZeitschritteData) => void;
    onZeitschritteDirtyChange?: (isDirty: boolean) => void;
    onInputFilesChange: (files: CSVFileEntry[]) => void;
    onTimeInfoChange: (data: TimeInformationDatabaseData) => void;
    onTimeInfoDirtyChange?: (isDirty: boolean) => void;
    onOutputFilesChange: (files: CSVFileEntry[]) => void;
    globalDuplicateBezeichnungIds?: Set<string>;
    onUploadComplete?: () => void;
    inputFileCount?: number;
}

const TrainingDataUpload = ({
    resetKey,
    zeitschritte,
    uploadSessionId,
    onZeitschritteChange,
    onZeitschritteDirtyChange,
    onInputFilesChange,
    onTimeInfoChange,
    onTimeInfoDirtyChange,
    onOutputFilesChange,
    globalDuplicateBezeichnungIds,
    onUploadComplete,
    inputFileCount = 0
}: TrainingDataUploadProps) => {
    return (
        <div className="space-y-6">
            <AllgemeineDaten
                key={`allgemeine-${resetKey}`}
                zeitschritte={zeitschritte}
                onChange={onZeitschritteChange}
                onDirtyChange={onZeitschritteDirtyChange}
                sessionId={uploadSessionId || undefined}
            />

            <CSVFileUploader
                key={`input-${resetKey}`}
                onFilesChange={onInputFilesChange}
                sessionId={uploadSessionId || undefined}
                zeitschritte={zeitschritte}
                globalDuplicateBezeichnungIds={globalDuplicateBezeichnungIds}
                onUploadComplete={onUploadComplete}
            />

            <TimeInformationInput
                key={`time-${resetKey}`}
                onChange={onTimeInfoChange}
                onDirtyChange={onTimeInfoDirtyChange}
                sessionId={uploadSessionId || undefined}
                inputFileCount={inputFileCount}
            />

            <OutputDataUploader
                key={`output-${resetKey}`}
                onFilesChange={onOutputFilesChange}
                sessionId={uploadSessionId || undefined}
                zeitschritte={zeitschritte}
                globalDuplicateBezeichnungIds={globalDuplicateBezeichnungIds}
                onUploadComplete={onUploadComplete}
            />
        </div>
    );
};

export default TrainingDataUpload;
